/**
 * Build the FormData payload for the V1 endpoint.
 */
export const buildV1FormData = (params) => {
    const formData = new FormData();
    formData.append('buyer_id', params.buyerId);
    formData.append(
        'channelIds_with_names',
        JSON.stringify(params.channels_with_names),
    );
    formData.append('setSelectedButton', params.setSelectedButtons[0]);
    formData.append(
        'current_startDate',
        params.current_startDate?.toISOString() || '',
    );
    formData.append(
        'current_endDate',
        params.current_endDate?.toISOString() || '',
    );
    formData.append(
        'previous_startDate',
        params.previous_startDate?.toISOString() || '',
    );
    formData.append(
        'previous_endDate',
        params.previous_endDate?.toISOString() || '',
    );
    formData.append('report_type', params.reportType || 'bad');
    return formData;
};

/**
 * Build the FormData payload for the V2 endpoint.
 */
export const buildV2FormData = (params) => {
    const formData = new FormData();
    formData.append('file', params.uploadFile);
    formData.append('buyer_id', params.buyerId);
    formData.append(
        'channelIds_with_names',
        JSON.stringify(params.channels_with_names),
    );
    formData.append('setSelectedButton', params.setSelectedButtons[0] || '');
    formData.append(
        'current_startDate',
        params.current_startDate?.toISOString() || '',
    );
    formData.append(
        'current_endDate',
        params.current_endDate?.toISOString() || '',
    );
    formData.append('identifier_column', params.identifierColumn);
    formData.append('funded_column', params.fundedColumn);
    formData.append(
        'funded_values',
        JSON.stringify(params.selectedFundedValues),
    );
    formData.append('existing_file_name', params.selectedExistingFile || '');
    formData.append('file_label', params.fileLabel || '');
    formData.append('report_type', params.reportType || 'bad');
    return formData;
};

